import React, { useState, useEffect } from "react";
import { Image_Url, Local_Image_Url } from "../../api/ApiClient";

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_PATH || Image_Url;
const LOCAL_IMAGE_BASE_URL = process.env.REACT_APP_LOCAL_IMAGE_PATH || Local_Image_Url;

const COLORS = [
    "#5e72e4", // Primary blue
    "#2dce89", // Success green
    "#11cdef", // Info cyan
    "#fb6340", // Warning orange
    "#f5365c", // Danger red
    "#8965e0", // Indigo
    "#ffd600", // Yellow
];

const getInitials = (name) => {
    if (!name) return "??";
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
};

const getColorFromName = (name) => {
    if (!name) return COLORS[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % COLORS.length;
    return COLORS[index];
};

const Avatar = ({ src, name, size = "md", className = "", style = {} }) => {
    const [imgError, setImgError] = useState(false);
    const [imgSrc, setImgSrc] = useState(null);

    useEffect(() => {
        setImgError(false);
        if (!src || src === "" || src === "default.jpg" || src === "no-user.png" || src === "avatar-1.jpg" || (typeof src === "string" && src.includes("/avatar-1.jpg"))) {
            setImgSrc(null);
        } else if (src.startsWith("http") || src.startsWith("blob:")) {
            setImgSrc(src);
        } else if (src.startsWith("avatar-")) {
            setImgSrc(`${LOCAL_IMAGE_BASE_URL}${src}`);
        } else {
            // Ensure no double slashes and that we have a valid path
            const base = IMAGE_BASE_URL.replace(/\/$/, "");
            const path = src.replace(/^\//, "");
            setImgSrc(`${base}/${path}`);
        }
    }, [src]);

    const sizeStyles = {
        xs: { width: "24px", height: "24px", fontSize: "10px" },
        sm: { width: "36px", height: "36px", fontSize: "12px" },
        md: { width: "45px", height: "45px", fontSize: "14px" },
        lg: { width: "58px", height: "58px", fontSize: "16px" },
        xl: { width: "110px", height: "110px", fontSize: "24px" },
    };

    const currentSizeStyle = sizeStyles[size] || sizeStyles.md;

    if (imgSrc && !imgError) {
        return (
            <img
                alt={name || "Avatar"}
                src={imgSrc}
                className={`avatar rounded-circle shadow-sm ${className}`}
                style={{
                    ...currentSizeStyle,
                    objectFit: "cover",
                    ...style,
                }}
                onError={() => setImgError(true)}
            />
        );
    }

    const initials = getInitials(name);
    const bgColor = getColorFromName(name);

    return (
        <div
            className={`avatar rounded-circle shadow-sm d-flex align-items-center justify-content-center text-white font-weight-bold button-primary ${className}`}
            style={{
                ...currentSizeStyle,
                ...style,
            }}
        >
            {initials}
        </div>
    );
};

export default Avatar;
